import React, { useState } from 'react';
import { Helmet } from 'react-helmet';
import { Flex, Box } from 'rebass';

import H1 from 'components/H1';
import AppPageWrapper from 'components/AppPageWrapper';
import AppPageWrapperSectionHeader from 'components/AppPageWrapper/AppPageWrapperSectionHeader';
import AppPageWrapperSectionBody from 'components/AppPageWrapper/AppPageWrapperSectionBody';
import SettingsPageSubNav from 'containers/SettingsPage/SettingsPageSubNav';
import { ActionButton } from 'components/Button/ActionButton';
import { CreateBrandingModal } from 'components/CreateBrandingModal';

/**
 * Branding Layout
 *
 * @param {React.Children} children
 * @returns {JSX.Element}
 */
export function BrandingLayout({ children }) {
    const [isModalOpen, setIsModalOpen] = useState(false);

    return (
        <>
            <AppPageWrapper>
                <Helmet>
                    <title>Branding Settings</title>
                </Helmet>
                <Flex>
                    <SettingsPageSubNav />
                </Flex>
                <AppPageWrapperSectionHeader className="experience">
                    <Box>
                        <H1>Branding</H1>
                        <Box className="experience-description text-secondary-dark">
                            Configure your branding settings.
                        </Box>
                    </Box>
                    <ActionButton title="New Branding" action={() => setIsModalOpen(true)} keyLabel="N" mr={0} />
                </AppPageWrapperSectionHeader>
                <AppPageWrapperSectionBody css={{ paddingTop: '32px', display: 'block' }}>
                    {children}
                </AppPageWrapperSectionBody>
            </AppPageWrapper>
            <CreateBrandingModal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} />
        </>
    );
}

export const withBrandingLayout = Component => props => (
    <BrandingLayout>
        <Component {...props} />
    </BrandingLayout>
);
